import React from "react";

// Define el tipo de las props
export type ColumnTaskProps = {
  date: string;
  task: string;
};

const ColumnTask: React.FC<ColumnTaskProps> = ({ date, task }) => {
  const formattedDate = new Date(date)
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .join("-");

  return (
    <td className="py-5 pl-4 pr-3 text-sm sm:pl-0 min-w-60">
      <div className="flex flex-col items-center">
        <div className="text-gray-900 w-full text-sm">
          {formattedDate}
        </div>
        <div className="mt-1 w-full">
          <div className="text-sm font-medium text-gray-500 w-60 line-clamp-3 break-words">
            {task}
          </div>
        </div>
      </div>
    </td>
  );
};

export default ColumnTask;